import { useState } from "react";
import { useTranslation } from "react-i18next";

import newId from "@sellernote/shared/src/utils/newId";
import { removeLeadingBlank } from "@sellernote/shared/src/utils/string";
import { TextAreaFieldProps } from "@sellernote/ui/src/utils/headless-components/form/useTextAreaField";

import Styled from "./index.styles";

export default function TextAreaField({
  labelInfo,
  value,
  setValue,
  width,
  height,
  placeholder,
  errorMessage,
  disabled,
  className,
}: TextAreaFieldProps) {
  // label id를 unique하게 사용하기 위함
  const [textAreaId] = useState(() => newId("text-area-field-id-"));

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(removeLeadingBlank(e.target.value));
  };

  const { t } = useTranslation("sds-v2");

  return (
    <Styled.container
      className={`${className ? className : ""} text-area-field`}
      width={width}
      height={height}
      disabled={disabled}
      hasError={!!errorMessage}
    >
      <label
        htmlFor={textAreaId}
        className={`${(labelInfo.isLabelHidden && "visually-hidden") ?? ""}`}
      >
        {labelInfo.label}
      </label>

      <div className="text-area-container">
        <textarea
          id={textAreaId}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          placeholder={placeholder || t("sds-v2:TextAreaField_입력_안내")}
        />
      </div>

      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </Styled.container>
  );
}
